.leftSpacing {
    margin-left: 10px;
}

.blackjack {
    font-size: 30px;
    font-weight: 800;
}

.standard {
    font-size: 25px;
}

.total {
    font-weight: 600;
}

.bust {
    font-size: 30px;
    font-weight: 800;
    color: red;
}